import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isBlank } from '@app/utils/string';

const C5_MAIL_REGEX = /^([^;:]+@[^;:]+(\.[a-zA-Z\u00C4\u00D6\u00DC\u00E4\u00F6\u00FC\u00DF\\d]+))$/;

export function C5EmailValidator(control: AbstractControl): ValidationErrors | null {
  let error: ValidationErrors | null;
  const value = control.value;

  if (value == null || isBlank(value)) {
    error = null;
  } else {
    if (C5_MAIL_REGEX.test(value) === false) {
      error = {
        email: true,
      };
    }
  }

  return error;
}
